<template>
    <q-list bordered>
        <q-item-label header class="row justify-between bg-grey-4">
            <div class="text-black text-h6">{{$t('transfers.send_money_steps.recipient')}}</div>
            <q-btn outline :label="$t('transfers.send_money_steps.change')" color="primary" @click="$emit('change')"/>
        </q-item-label>

        <q-item>
            <recipient-sticky-note
                :recipient-name="recipient.name"
                :payment-method="recipient.type"
                :bank-name="recipient.bank"
                :label1="recipient.label1"
                :label2="recipient.label2"
                :account-number="recipient.account_number"
                :notes="recipient.notes"
            />
        </q-item>
    </q-list>
</template>
<script>
import RecipientStickyNote from 'Modules/Recipient/resources/components/RecipientStickyNote'

export default {
    name: "ReviewRecipient",
    props: {
        recipient: {
            type: Object,
            required: true
        }
    },
    computed: {},
    data() {
        return {}
    },
    methods: {},
    created() {

    },
    mounted() {

    },
    components: {
        RecipientStickyNote
    },
}
</script>
<style>

</style>
